import React from 'react';
import Icon from '../../../components/AppIcon';

const TypingIndicator = () => {
  return (
    <div className="flex gap-3 md:gap-4 mb-4 md:mb-6">
      <div className="flex-shrink-0">
        <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
          <Icon name="Bot" size={20} color="#FFFFFF" />
        </div>
      </div>

      <div className="flex-1 max-w-[85%] md:max-w-[75%]">
        <div className="rounded-2xl rounded-tl-sm px-4 py-3 md:px-5 md:py-4 bg-card border border-border inline-block">
          <div className="flex items-center gap-2">
            <div className="flex gap-1">
              <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
              <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
              <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
            </div>
            <span className="text-xs md:text-sm text-muted-foreground">
              L'IA analyse votre question...
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;